import(/* webpackMode: "eager" */ "/var/www/html/gsfcarparts/nextjs/src/app/[locale]/(default-layout)/error.jsx")